import { schema } from "normalizr"
import moduleModel from "../modules/item"
import licence from "../licences/item"

export default new schema.Object({
  moduleModel,
  licence,
})
